module.exports = __webpack_public_path__ + "img/storedetails@2x.58a6c7a.jpg";